import tw from 'twin.macro'

const centerToContentColumn = () =>
  tw`mx-auto w-full max-w-content-column px-content-column-padding`

export default centerToContentColumn
